<div class="modal-container">
  <div class="modal-header border-0">
    <h1 class="modal-title text-center text-primary-color">{{ title }} Manufacturer</h1>
  </div>
  <div class="modal-body">
    <div *ngIf="title == 'Add'" class="container p-0">
      <div class="row">
        <div class="col-11">
          <app-input
            [inputLabel]="'Manufacturer Name'"
            [inputType]="'text'"
            [inputValue]="manufacturerModelInsertUpdate.manufacturerName"
            (inputValueEmit)="manufacturerModelInsertUpdate.manufacturerName = $event"
            [inputReqValidation]="data?.addRelatedEntity?false:true"
            [ngClass]="{'border-red':!manufacturerModelInsertUpdate.manufacturerName && submit}"
            [isInputDisabled]="data?.addRelatedEntity"
          >
          </app-input>
        </div>
        <div class="col py-3">
          <div class="d-flex checkbox-solid-info show-inactive">
            <app-checkbox
              [status]="manufacturerModelInsertUpdate?.isSubManufacturer"
              [lableName]="'Add Sub Manufacturers'"
              [lableClass]="'text-light-gray'"
              [dyanamicId]="'text-light-gray'"
              (check)="onCheckboxChange($event)"
              [isSelectedAdmin]="data?.addRelatedEntity"
            >
            </app-checkbox>
          </div>
        </div>
        <div class="col-12 mb-1">
          <h6 class="modal-title text-primary-color mb-3 tab-view">
            Select {{manufacturerModelInsertUpdate?.isSubManufacturer?'Sub':'Primary'}} Manufacturer  {{data?.addRelatedEntity?'':'(optional)'}}
          </h6>
          <div class="row"
          [ngClass]="{'wrapper':dropdownList?.length > 2}">
          <div class="d-flex"  *ngFor="let dropdown of dropdownList; let i = index"> 
            <div class="col-11 pb-3 pe-2px" >
              <app-search-bar-dropdown
              class="search-dropdown"
              [id]="'LinkManufacturer'" 
              [name]="'LinkManufacturer'"
              [searchDropdown]="true"
              [selectLabel]="'Link Manufacturer'"  
              (addNewRecord)="addNewRecord($event)"
              [newRecord]="true"
              (inputValueEmit)="selectedValue($event)"
              [dataList]="manufacturerModelInsertUpdate?.isSubManufacturer? primaryManufacturerList:manufacturerList">
            </app-search-bar-dropdown>
            </div>
            <div class="col-1 ps-3 pb-3 d-flex align-items-center">
              <div [ngClass]="{ 'visible': i > 0, 'invisible': i === 0 }">
               <app-svg
              iconType="Delete"
              (click)="deleteDropdown(i)"
              class="">
            </app-svg>

              </div>

            </div>
          </div> 
          </div>
          <div class="row">
          <div class="col" [ngClass]="{'invisible':!manufacturerModelInsertUpdate?.isSubManufacturer,
            'pt-3':dropdownList?.length > 2
          }">
            <label
            for=""
            class="text-secondary-color hand"
            (click)="linkAdditional()"
            >+ Link Additional
          </label>
         </div>
        </div>
        </div>
      </div>
    </div>
    <div *ngIf="title == 'Edit'">
      <div class="row">
        <div class="col-12">
          <span class="d-flex font-13 text-gray">Current Manufacturer Name</span>
          <span class="font-13 text-primary-color text-truncate  d-block w-100">{{data?.updateManufacturerModel?.manufacturerName ? data?.updateManufacturerModel?.manufacturerName : '-'}}</span>
        </div>
        <div class="col-12 py-3">
          <span class="d-flex font-13 text-gray pb-2">New Manufacturer Name</span>
          <app-input
          [inputLabel]="'Manufacturer Name'"
          [inputType]="'text'"
          [inputValue]="updateManufacturerModel.manufacturerName"
          (inputValueEmit)="updateManufacturerModel.manufacturerName = $event"
          [inputReqValidation]="true"
          [ngClass]="{ 'border-red': !updateManufacturerModel.manufacturerName && submit }"
        >
        </app-input>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-end border-0">
      <div class="m-0 d-flex gap-3">
        <app-button
          class=""
          [buttonType]="'button'"
          [button_2]="true"
          [buttonClass]="'button button-info popup-button'"
          (click)="activeModal.close(true)"
          [buttonLable]="enumButtonName.CANCEL"
        ></app-button>
        <app-button
          class=""
          [buttonType]="'submit'"
          [button_2]="true"
          [buttonClass]="'button popup-button' + (updateManufacturerModel.manufacturerName ? ' button-primary ' : ' dark-info')"
          [buttonLable]="title === enumButtonName.EDIT ? enumButtonName.SAVE: enumButtonName.ADD"
          (click)="data?.updateManufacturerModel?.manufacturerId? updateManufacturer(): data?.addRelatedEntity?addRelatedEntityManufacturer():addManufacturer()"
        ></app-button>
      </div>
    </div>
  </div>
</div>
